import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ResetSidebarService {

  constructor() { }

  resetStatus = new BehaviorSubject(<string>'');
  passResetStatus(status) {
    this.resetStatus.next(status);
  }

  passResetJustAdded(justAdded) {
    this.resetStatus.next(justAdded);
  }

}
